import { createPinia, setActivePinia } from 'pinia'

/**
 * The one Pinia. main.js created it inline; every island installs this same
 * instance, or two islands would hold two copies of the session. The stores
 * themselves are Zustand since sub-plan 1B — these are mirror shells
 * (core/state/mirror.ts).
 *
 * It is activated here, at module load, not only when an island installs it.
 * Seven modules call `useAppStore()` outside any component — the axios request
 * interceptor (`core/api/client.js:174`) most importantly, plus the cache
 * layer. While Vue owned the root that was safe: `app.use(pinia)` ran before
 * anything could issue a request. React owns the root now and the frame fetches
 * before the island mounts, so without this the first request threw
 * "Cannot read properties of undefined" inside the interceptor, sent no
 * Authorization header, and the workspace fell back to 0 — a 401 and the demo
 * workspace's data.
 */
export const pinia = createPinia()

setActivePinia(pinia)
